import './SubscribeModal.css'

import React, { useEffect, useState } from 'react'

import IconPhone from '../assets/IconPhone.svg'
import IconSmartphone from '../assets/IconSmartphone.svg'
import IconSMS from '../assets/IconSMS.svg'
import IconStore from '../assets/IconStore.svg'
import { Trans, useTranslation } from 'react-i18next'
import Cross from '../assets/Cross.svg'
import localhostSettings from '../local'

interface SubscribeModalProps {
  isOpen: boolean
  onClose: () => void
  hit: any | null
}

const SubscribeModal: React.FC<SubscribeModalProps> = ({ isOpen, onClose, hit }) => {
  const [appDownloadURL, setAppDownloadURL] = useState("")
  const isRTL = localhostSettings.isRTL()
  const { t } = useTranslation()
  useEffect(() => {
    getMobileOperatingSystem()
  }, [])
  // Helper function to safely get name string from hit.name
  function getName(hit: any): string {
    if (!hit.name) return ''
    if (typeof hit.name === 'string') return hit.name
    if (typeof hit.name === 'object' && 'valueEn' in hit.name) return hit.name.valueEn
    return ''
  }
  if (!isOpen || !hit) return null

  const specs = hit.specCharacteristics || []
  const getValue = (code: string) => specs.find((s: any) => s.code === code)?.[isRTL ? 'valueAr' : 'valueEn'] || ''
  const title = isRTL ? hit?.name?.valueAr : hit?.name?.valueEn;
  const subscriptionCommand = getValue('subscriptionCommand_BM')

  function getMobileOperatingSystem() {
    let userAgent = navigator.userAgent || navigator.vendor;
    // Windows Phone must come first because its UA also contains "Android"
    if (/android/i.test(userAgent)) {
      setAppDownloadURL("https://play.google.com/store/apps/details?id=com.mobily.activity")
    } else if (/huawei/i.test(userAgent)) {
      ;
      setAppDownloadURL("https://appgallery.huawei.com/app/C101532351")
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      setAppDownloadURL("https://apps.apple.com/sa/app/mobily-%D9%85%D9%88%D8%A8%D8%A7%D9%8A%D9%84%D9%8A/id375539359")
    } else {
      setAppDownloadURL("https://apps.apple.com/sa/app/mobily-%D9%85%D9%88%D8%A8%D8%A7%D9%8A%D9%84%D9%8A/id375539359")
    }
  }
  return (
    <div className="s-modal-overlay">
      <div className="s-modal-content">
        <button className="s-close-btn" onClick={onClose}>
          <img src={Cross} alt='close' />
        </button>
        <h2 className="s-title">{title}</h2>
        <h3 className="s-subtitle">{t('Ways_to_subscribe')}</h3>

        <ul className="s-list">
          <li>
            <img src={IconSMS} className="s-icon" />
            <div className="s-text-block">
              <strong>{t("By_SMS")}</strong>
              <span>
                <Trans
                  i18nKey="By_SMS_Send_code"
                  components={{
                    strong1: <strong className="sms-code" />,
                    link1: <a href="tel:1100" />,
                  }}
                  values={{ subscriptionCommand }}
                />
              </span>
            </div>
          </li>

          <li>
            <img src={IconSmartphone} className="s-icon" />{' '}
            <div className="s-text-block">
              <strong>{t("On_App")}</strong>
              <span>
                <Trans
                  i18nKey="On_App_Find_your_bundle"
                  components={{
                    link1: <a href={appDownloadURL} />
                  }}
                />
              </span>
            </div>
          </li>
          <li>
            <img src={IconStore} className="s-icon" />{' '}
            <div className="s-text-block">
              <strong>
                {t("On_branch")}
              </strong>
              <span>
                <Trans
                  i18nKey="On_branch_Visit_one_of_our_Mobily_branches"
                />{' '}
                <a href="/wps/portal/web/store-locator">{t("Find_a_branch")}</a>
              </span>
            </div>
          </li>
          <li>
            <img src={IconPhone} className="s-icon" />
            <div className="s-text-block">
              <span className="s-label">{t("By_call")}</span>
              <span className="s-description">
                <Trans
                  i18nKey="Call_or_and_choose_your_bundle_from"
                  components={{
                    link2: <a href="tel:1100" />,
                    link1: <a href="tel:0560101100" />
                  }}
                />
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default SubscribeModal
